export enum SegmentProjectID {
  PRODUCTION = "AtOCHVqKlZIuq5mw3eDaQu3ekri6wd3A",
  STAGING = "R2LynVRb5dIkLZLQl34Mg8NorL80zKVs",
  DEVELOP = "TScbCALzTOFCCI9kXayeU7NuK04852Ur"
}
